import { GetterTree } from 'vuex'
import { BoothApplication, BoothApplicationsState } from '@/store/applications/booths/types'
import { RootState } from '@/store/types'

const getters : GetterTree<BoothApplicationsState, RootState> = {
  /**
   * 申請IDを元に休暇申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {BoothApplication|null} 申請情報
   */
  findBoothApplicationById: (state) => (applicationId: string): BoothApplication|null => {
    return state.applications.find((app: BoothApplication) => app.id === applicationId) || null
  },
}

export default getters
